// extracted by mini-css-extract-plugin
export default {"rowLabel":"AdditionalInfoItem_rowLabel__FqWrq","fieldOverride":"AdditionalInfoItem_fieldOverride__Dx512"};